import React from 'react';
import { Box } from '@mui/material';
import { Button, Typography, colors } from '@leapeasy/ui-kit';

export class ClaimFormErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (typeof this.props.onError === 'function') {
      this.props.onError(error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box display="flex" flexDirection="column" gap="12px" py={2}>
          <Typography variant="body1" style={{ fontWeight: 600, color: colors.purple[900] }}>
            Unable to open the claim form
          </Typography>
          <Typography variant="body2" style={{ color: colors.neutral[900] }}>
            Something went wrong while loading this form. Close and try again, or file the claim
            from the main Claims menu.
          </Typography>
          {typeof this.props.onClose === 'function' ? (
            <Button variant="primary" size="medium" onClick={this.props.onClose}>
              Close
            </Button>
          ) : null}
        </Box>
      );
    }

    return this.props.children;
  }
}
